// // /* eslint-disable @typescript-eslint/no-unused-vars */
// // // import Home from '../pages/home/home.jsx';

// // import App from '../App.jsx';
// // import { Navigate, createBrowserRouter } from 'react-router-dom';
// // import PagesError from '../pages/PagesError/PagesError.jsx';

// // // الصفحات العامة والخاصة
// // import Login from '../pages/Login/Login.jsx';
// // import ConfirmPassword from '../pages/Login/ConfirmPassword';
// // import CustomerDisplay from '../pages/POS/PointOfSale/CustomerDisplay.jsx';
// // import PayrollForPerson from '../pages/HR/payroll/PayrollRun/Report/PayrollForPerson.jsx';
// // import PayrollForAll from '../pages/HR/payroll/PayrollRun/Report/PayrollForAll.jsx';

// // // لوحة التحكم
// // import UserDashboard from '../pages/dashboard/UserDashboard/UserDashboard';

// // // مسارات الوحدات
// // import payrollRoutes from './Routes/PayrollRoutes';
// // import raqeebRoutes from './Routes/RaqeebRoutes';
// // import hrRoutes from './Routes/HRRoutes';
// // import ameRoutes from './Routes/AmeRoutes';
// // import fleetRoutes from './Routes/FleetRoutes.jsx';
// // import notificationsRoutes from './Routes/NotificationsRoutes';
// // import reportsRoutes from './Routes/ReportsRoutes';
// // import suRoutes from './Routes/SuRoutes';
// // import financeRoutes from './Routes/FinanceRoutes';
// // import apRoutes from './Routes/ApRoutes.tsx';
// // import arRoutes from './Routes/ArRoutes';
// // import salesRoutes from './Routes/SalesRoutes';
// // import purchasesRoutes from './Routes/purchasesRoutes';
// // import inventoryRoutes from './Routes/InventoryRoutes';
// // import posRoutes from './Routes/PosRoutes';
// // import ntxRoutes from './Routes/NtxRoutes';
// // import projectRoutes from './Routes/projectRoutes';
// // import securityRoutes from './Routes/SecurityRoutes';
// // import MrpRoutes from './Routes/MrpRoutes.jsx';
// // import assetsRoutes from './Routes/FaAssetsRoutes.jsx';
// // import HandoverTakeoverPrint from '@pages/FLEET/HandOverTakeOver/Print';
// // import ErrorBoundary from './ErrorBoundary';
// // import { isTokenValid } from '@Helper/Helper';
// // import IntegrationRoutes from './Routes/IntegrationRoutes.jsx';

// // const ProtectedRoute = ({ children }: any) => {
// //   const valid = isTokenValid();
// //   return valid ? children : <Navigate to='/login' replace />;
// // };

// // // مكون إعادة التوجيه من اللوجن في حال المستخدم مسجل بالفعل
// // const PublicRoute = ({ children }: any) => {
// //   const valid = isTokenValid();
// //   return valid ? <Navigate to='/UserDashboard' replace /> : children;
// // };

// // const AppRoute = createBrowserRouter([
// //   {
// //     path: '/',
// //     element: (
// //       <ProtectedRoute>
// //         <ErrorBoundary>
// //           <App />
// //         </ErrorBoundary>
// //       </ProtectedRoute>
// //     ),
// //     errorElement: <PagesError />,
// //     children: [
// //       { path: '', element: <Navigate to='/home' /> },

// //       { index: true, element: <Navigate to='/login' replace /> },
// //       { path: 'UserDashboard', element: <UserDashboard /> },
// //       // { path: 'SystemDashboard', element: <SystemDashboard /> },

// //       // إضافة مسارات الوحدات
// //       ...hrRoutes,
// //       ...payrollRoutes,
// //       ...raqeebRoutes,
// //       ...ameRoutes,
// //       ...fleetRoutes,
// //       ...notificationsRoutes,
// //       ...reportsRoutes,
// //       ...suRoutes,
// //       ...financeRoutes,
// //       ...assetsRoutes,
// //       ...apRoutes,
// //       ...arRoutes,
// //       ...salesRoutes,
// //       ...purchasesRoutes,
// //       ...inventoryRoutes,
// //       ...posRoutes,
// //       ...ntxRoutes,
// //       ...securityRoutes,
// //       ...MrpRoutes,
// //       ...IntegrationRoutes,
// //        ...projectRoutes,
// //     ]
// //   },

// //   // 🔓 المسارات خارج <App> (بدون layout)
// //   {
// //     path: '/Pos/CustomerDisplay',
// //     element: <CustomerDisplay />
// //   },
// //   {
// //     path: '/Report/:AssignmentActionId/PayrollForPerson',
// //     element: <PayrollForPerson />
// //   },
// //   {
// //     path: '/Report/:PayrollActionId/PayrollForAll',
// //     element: <PayrollForAll />
// //   },
// //   {
// //     path: '/FLEET/Print/:assignationId/:scanningType',
// //     element: <HandoverTakeoverPrint />
// //   },
// //   {
// //     path: '/login',
// //     children: [
// //       {
// //         index: true,
// //         element: (
// //           <PublicRoute>
// //             <Login />
// //           </PublicRoute>
// //         )
// //       },
// //       {
// //         path: 'ConfirmPassword',
// //         element: <ConfirmPassword />
// //       }
// //     ]
// //   },

// //   {
// //     path: '*',
// //     element: <PagesError />
// //   }
// // ]);

// // export default AppRoute;
// // // // 🌐 مسار عام لجميع ما لم يُFOUND (404)
// // //   {
// // //     path: '*',
// // //     element: <PagesError />
// // //   }

// // // {
// // //   future: {
// // //     // v7_relativeSplatPath: true,
// // //     // v7_fetcherPersist: true,
// // //     // v7_normalizeFormMethod: true,
// // //     // v7_partialHydration: true,
// // //     // v7_skipActionErrorRevalidation: true
// // //   }
// // // }

// // src/router/AppRoute.tsx

// import { Navigate, createBrowserRouter, redirect } from 'react-router';
// import PagesError from '../pages/PagesError/PagesError.jsx';
// import ErrorBoundary from './ErrorBoundary';
//  import { isTokenValid } from '@Helper/Helper';

// // ===== Module Routes (arrays) =====
// import payrollRoutes from './Routes/PayrollRoutes.tsx';
// import raqeebRoutes from './Routes/RaqeebRoutes.tsx';
// import hrRoutes from './Routes/HRRoutes.tsx';
// import ameRoutes from './Routes/AmeRoutes.tsx';
// import fleetRoutes from './Routes/FleetRoutes.tsx';
// import notificationsRoutes from './Routes/NotificationsRoutes.tsx';
// import reportsRoutes from './Routes/ReportsRoutes.tsx';
// import suRoutes from './Routes/SuRoutes.tsx';
// import financeRoutes from './Routes/FinanceRoutes.tsx';
// import apRoutes from './Routes/ApRoutes.tsx';
// import arRoutes from './Routes/ArRoutes.tsx';
// import salesRoutes from './Routes/SalesRoutes.tsx';
// import purchasesRoutes from './Routes/purchasesRoutes.tsx';
// import inventoryRoutes from './Routes/InventoryRoutes.tsx';
// import posRoutes from './Routes/PosRoutes.tsx';
// import ntxRoutes from './Routes/NtxRoutes.tsx';
// import projectRoutes from './Routes/projectRoutes.tsx';
// import securityRoutes from './Routes/SecurityRoutes.tsx';
// import MrpRoutes from './Routes/MrpRoutes.tsx';
// import assetsRoutes from './Routes/FaAssetsRoutes.jsx';
// import IntegrationRoutes from './Routes/IntegrationRoutes.tsx';
// import RouteFallback from './utils/RouteFallback.js';

// // ===== Guards as loaders =====
// const requireAuth = () => {
//   if (!isTokenValid()) throw redirect('/login');
//   return null;
// };

// const publicOnly = () => {
//   if (isTokenValid()) throw redirect('/UserDashboard');
//   return null;
// };

// // ===== Router =====
// const AppRoute = createBrowserRouter(
//   [
//     {
//       path: '/',
//       loader: requireAuth,

//       // ✅ بديل fallbackElement في v7
//       hydrateFallbackElement: <RouteFallback />,

//       lazy: async () => {
//         const { default: App } = await import('../App.jsx');
//         return {
//           Component: () => (
//             <ErrorBoundary>
//               <App />
//             </ErrorBoundary>
//           )
//         };
//       },

//       errorElement: <PagesError />,

//       children: [
//         // الافتراضي داخل النظام بعد الدخول
//         { index: true, element: <Navigate to="/UserDashboard" replace /> },

//         // لوحة التحكم
//         {
//           path: 'UserDashboard',
//           lazy: async () => ({ Component: (await import('../pages/dashboard/UserDashboard/UserDashboard')).default })
//         },

//         // ===== Modules =====
//         ...hrRoutes,
//         ...payrollRoutes,
//         ...raqeebRoutes,
//         ...ameRoutes,
//         ...fleetRoutes,
//         ...notificationsRoutes,
//         ...reportsRoutes,
//         ...suRoutes,
//         ...financeRoutes,
//         ...assetsRoutes,
//         ...apRoutes,
//         ...arRoutes,
//         ...salesRoutes,
//         ...purchasesRoutes,
//         ...inventoryRoutes,
//         ...posRoutes,
//         ...ntxRoutes,
//         ...securityRoutes,
//         ...MrpRoutes,
//         ...IntegrationRoutes,
//         ...projectRoutes
//       ]
//     },

//     // 🔓 المسارات خارج <App> (بدون layout) — نفس سلوكك السابق (بدون حماية)
//     {
//       path: '/Pos/CustomerDisplay',
//       lazy: async () => ({ Component: (await import('../pages/POS/PointOfSale/CustomerDisplay.jsx')).default })
//     },
//     {
//       path: '/Report/:AssignmentActionId/PayrollForPerson',
//       lazy: async () => ({ Component: (await import('../pages/HR/payroll/PayrollRun/Report/PayrollForPerson.jsx')).default })
//     },
//     {
//       path: '/Report/:PayrollActionId/PayrollForAll',
//       lazy: async () => ({ Component: (await import('../pages/HR/payroll/PayrollRun/Report/PayrollForAll.jsx')).default })
//     },
//     {
//       path: '/FLEET/Print/:assignationId/:scanningType',
//       lazy: async () => ({ Component: (await import('@pages/FLEET/HandOverTakeOver/Print')).default })
//     },

//     // Login (Public only)
//     {
//       path: '/login',
//       loader: publicOnly,
//       hydrateFallbackElement: <RouteFallback />,
//       children: [
//         {
//           index: true,
//           lazy: async () => ({ Component: (await import('../pages/Login/Login.jsx')).default })
//         },
//         {
//           path: 'ConfirmPassword',
//           lazy: async () => ({ Component: (await import('../pages/Login/ConfirmPassword')).default })
//         }
//       ]
//     },

//     { path: '*', element: <PagesError /> }
//   ],
//   {
//     // ✅ لو عندك تحذيرات hydration في v7، هذا يمنعها غالبًا
//     future: { v7_partialHydration: true }
//   }
// );

// export default AppRoute;

// src/router/AppRoute.tsx
import { Navigate, createBrowserRouter, redirect, type RouteObject } from 'react-router';
import PagesError from '../pages/PagesError/PagesError.jsx';
import ErrorBoundary from './ErrorBoundary';
import { isTokenValid } from '@Helper/Helper';
import RouteFallback from './utils/RouteFallback.js';

// ===== Module Routes (arrays) =====
import payrollRoutes from './Routes/PayrollRoutes.tsx';
import raqeebRoutes from './Routes/RaqeebRoutes.tsx';
import hrRoutes from './Routes/HRRoutes.tsx';
import ameRoutes from './Routes/AmeRoutes.tsx';
import fleetRoutes from './Routes/FleetRoutes.tsx';
import notificationsRoutes from './Routes/NotificationsRoutes.tsx';
import reportsRoutes from './Routes/ReportsRoutes.tsx';
import suRoutes from './Routes/SuRoutes.tsx';
import financeRoutes from './Routes/FinanceRoutes.tsx';
import apRoutes from './Routes/ApRoutes.tsx';
import arRoutes from './Routes/ArRoutes.tsx';
import salesRoutes from './Routes/SalesRoutes.tsx';
import purchasesRoutes from './Routes/purchasesRoutes.tsx';
import inventoryRoutes from './Routes/InventoryRoutes.tsx';
import posRoutes from './Routes/PosRoutes.tsx';
import ntxRoutes from './Routes/NtxRoutes.tsx';
import projectRoutes from './Routes/projectRoutes.tsx';
import securityRoutes from './Routes/SecurityRoutes.tsx';
import MrpRoutes from './Routes/MrpRoutes.tsx';
import assetsRoutes from './Routes/FaAssetsRoutes.jsx';
import IntegrationRoutes from './Routes/IntegrationRoutes.tsx';
import CashRoutes from './Routes/CashRoutes.tsx';

// ===== Helpers =====
const lazyDefault = (importer: () => Promise<any>) => ({
  lazy: async () => {
    const mod = await importer();
    return { Component: mod.default };
  }
});

// ===== Guards as loaders =====
const requireAuth = () => {
  if (!isTokenValid()) throw redirect('/login');
  return null;
};

const publicOnly = () => {
  if (isTokenValid()) throw redirect('/UserDashboard');
  return null;
};

const routes: RouteObject[] = [
  {
    path: '/',
    loader: requireAuth,
    shouldRevalidate: () => false, // تحسين سريع (إذا ما تحتاج تعيد التحقق كل تنقل): 

    // ✅ بديل RouterProvider.fallbackElement (في v7)
    hydrateFallbackElement: <RouteFallback />,

    lazy: async () => {
      // if (import.meta.env.DEV) {
      //   await new Promise(r => setTimeout(r, 1000));
      // }
      const { default: App } = await import('../App.jsx');
      return {
        Component: () => (
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        )
      };
    },

    errorElement: <PagesError />,

    children: [
      // ✅ غيّرها لو ما عندك /home فعلياً
      { index: true, element: <Navigate to='/UserDashboard' replace /> },

      { path: 'UserDashboard', ...lazyDefault(() => import('../pages/dashboard/UserDashboard/UserDashboard')) },

      // ===== Modules =====
      ...hrRoutes,
      ...payrollRoutes,
      ...raqeebRoutes,
      ...ameRoutes,
      ...fleetRoutes,
      ...notificationsRoutes,
      ...reportsRoutes,
      ...suRoutes,
      ...financeRoutes,
      ...assetsRoutes,
      ...apRoutes,
      ...arRoutes,
      ...salesRoutes,
      ...purchasesRoutes,
      ...inventoryRoutes,
      ...posRoutes,
      ...ntxRoutes,
      ...securityRoutes,
      ...MrpRoutes,
      ...CashRoutes,

      // ⚠️ لو ntXRoutes فيه INT/Integration احذف واحد من المكانين
      ...IntegrationRoutes,

      ...projectRoutes
    ]
  },

  // 🔓 المسارات خارج <App> (بدون layout)
  // { path: '/Pos/CustomerDisplay', ...lazyDefault(() => import('../pages/POS/PointOfSale/CustomerDisplay.jsx')) },
  {
    path: '/Report/:AssignmentActionId/PayrollForPerson',
    ...lazyDefault(() => import('../pages/HR/payroll/PayrollRun/Report/PayrollForPerson.jsx'))
  },
  {
    path: '/Report/:PayrollActionId/PayrollForAll',
    ...lazyDefault(() => import('../pages/HR/payroll/PayrollRun/Report/PayrollForAll.jsx'))
  },
  {
    path: '/FLEET/Print/:assignationId/:scanningType',
    ...lazyDefault(() => import('@pages/FLEET/HandOverTakeOver/Print'))
  },

  // Login (Public only)
  {
    path: '/login',
    loader: publicOnly,
    hydrateFallbackElement: <RouteFallback />,
    children: [
      { index: true, ...lazyDefault(() => import('../pages/Login/Login.jsx')) },
      { path: 'ConfirmPassword', ...lazyDefault(() => import('../pages/Login/ConfirmPassword')) }
    ]
  },

  { path: '*', element: <PagesError /> }
];

const AppRoute = createBrowserRouter(routes, {
  future: { v7_partialHydration: true }
});

export default AppRoute;
